import React from 'react'
import { Portal } from 'react-portal'

import { WorkspaceAccessLevelDropdown } from '../WorkspaceAccessLevelDropdown'
import { ShareForSettingsModal } from '../types'
import ConfirmationDialog from 'components/ConfirmationDialog'
import { capitalize } from 'utils'
import { useUpdateWorkspace } from './useUpdateWorkspace'
import { useGetWorkspaceMembershipsCountQuery } from 'gqlTypes'

interface ShareForWorkspacePermissions {
  share: Pick<
    ShareForSettingsModal,
    | 'identifier'
    | 'workspaceCommentsEnabled'
    | 'workspaceAccessLevel'
    | 'libraryEnabled'
    | 'allowedWorkspaceAccessLevels'
    | 'isDraft'
    | 'workspace'
  >
}

const WorkspacePermissions = ({ share }: ShareForWorkspacePermissions) => {
  const { data } = useGetWorkspaceMembershipsCountQuery({
    variables: { workspaceId: share.workspace.identifier },
  })

  const {
    getUpdateWorkspaceConfirmDialogProps,
    getUpdateWorkspaceDropdownProps,
    updateWorkspaceConfirmDialogOpen,
    updateWorkspaceLevel,
  } = useUpdateWorkspace({ share })
  return (
    <div data-testid="workspace-access-level-dropdown">
      <WorkspaceAccessLevelDropdown
        share={share}
        workspaceMembersCount={
          data?.workspace.memberships.totalMemberships?.meta.totalCount
        }
        {...getUpdateWorkspaceDropdownProps()}
      />
      {updateWorkspaceConfirmDialogOpen && (
        <Portal>
          <ConfirmationDialog
            {...getUpdateWorkspaceConfirmDialogProps()}
            title={`Change workspace permissions to ${capitalize(
              updateWorkspaceLevel
            )}?`}>
            You will no longer be able to edit this document. If you need Edit
            permissions again later, ask a Workspace Admin.
          </ConfirmationDialog>
        </Portal>
      )}
    </div>
  )
}

export { WorkspacePermissions }
